/* ============================================================
   Floral — first-order variety-pack offer page (v4, 2026-08-25).
   Page loads as the real PDP (default Cocktail 2.5mg): one hero image +
   thumbnail strip, ATC always visible. Type/Strength/Sweetener pills sit
   where Bundle & Save sits on flavor PDPs; Bundle & Save under the
   pictures REMOVED 2026-10-12 (Adam: the page carries ONE offer, not two);
   one-time ONLY (subscribe row and one-time price box removed — the green
   ATC button carries crossed-out MSRP + bold orange deal price, with the
   orange SINGLE OFFER LINE under it: "20% + FREE shipping" once the
   discounted total reaches the hero's free-shipping threshold, otherwise
   "$X more unlocks FREE shipping").
   - Default quantity tile = the panel's default_qty setting (10-12: 2).
   - Quantity = PDP-style tiles 1–4, each a real Size VARIANT; cart write =
     variant x 1, submit-time assertion (no quantity arithmetic, ever).
   - Thumb strip always shows ALL packs' pictures (foreign thumbs moved in;
     clicking swaps the hero image only — product switching is the pills).
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var hero = document.querySelector('[data-ffo-hero]');
    if (!hero) return;
    var selectors = hero.querySelector('[data-ffo-selectors]');
    var offerBlock = hero.querySelector('[data-ffo-offer]');
    var discountPct = parseFloat(hero.dataset.ffoDiscount || '20');
    var fsThreshold = parseFloat(hero.dataset.ffoFsThreshold || '0') || 0;
    var lineFs = hero.dataset.ffoLineFs || '';
    var lineNoFs = hero.dataset.ffoLineNofs || '';

    var panels = {};
    document.querySelectorAll('[data-ffo-panel]').forEach(function (el) { panels[el.dataset.ffoPanel] = el; });
    var missing = {};
    document.querySelectorAll('[data-ffo-panel-missing]').forEach(function (el) { missing[el.dataset.ffoPanelMissing] = true; });
    if (!selectors || Object.keys(panels).length === 0) return;

    var state = { type: 'cocktail', strength: '2.5' }; // sweetener fixed: Cane Sugar
    // The panel the template marks "Visible on load" is the default pack.
    Object.keys(panels).some(function (k) {
      if (panels[k].hidden) return false;
      var parts = k.split('-');
      state = { type: parts[0], strength: parts.slice(1).join('-') };
      return true;
    });

    // Arm the discount for every visitor: Shopify only auto-applies a code
    // when the session passed through /discount/CODE, so fire that request
    // silently — the 302 response sets the discount cookie; checkout then
    // shows the code pre-applied (Adam 08-25: "amend it to work").
    var code = hero.dataset.ffoCode;
    if (code) {
      try { fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'manual', credentials: 'same-origin' }).catch(function () {}); }
      catch (e) { /* non-blocking */ }
    }

    function money(v) { return '$' + v.toFixed(2); }

    /* ---------- per-panel wiring ---------- */
    function initPanel(panel) {
      var form = panel.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;

      // One-time only: tiles, subscribe row, AND the one-time price box go.
      panel.querySelectorAll('floral-quantity-tiles').forEach(function (el) { el.remove(); });
      panel.querySelectorAll('.floral-purchase-type__row--sub').forEach(function (el) { el.remove(); });
      panel.querySelectorAll('.floral-purchase-type__row--one').forEach(function (el) { el.remove(); });
      // One offer only: the shared buy panel's Bundle & Save card goes too.
      panel.querySelectorAll('floral-bundle-save').forEach(function (el) { el.remove(); });

      // Thumb strip always shows every pack's pictures.
      var galleryEl = panel.querySelector('floral-product-gallery');
      var thumbsWrap = galleryEl && galleryEl.querySelector('.floral-product-gallery__thumbs');
      var mainImg = galleryEl && galleryEl.querySelector('[data-gallery-main] img');
      if (galleryEl && !thumbsWrap) {
        thumbsWrap = document.createElement('div');
        thumbsWrap.className = 'floral-product-gallery__thumbs';
        galleryEl.appendChild(thumbsWrap);
      }
      var foreign = panel.querySelector('[data-ffo-foreign]');
      if (foreign && thumbsWrap) {
        while (foreign.firstElementChild) thumbsWrap.appendChild(foreign.firstElementChild);
        foreign.remove();
      }
      if (thumbsWrap && mainImg) {
        // One delegated handler for every thumb (native + foreign): swap the
        // hero image and keep a single active thumb. Runs after the theme's
        // own handler, so it simply enforces the final state.
        thumbsWrap.addEventListener('click', function (e) {
          var btn = e.target.closest('.floral-product-gallery__thumb');
          if (!btn) return;
          if (btn.dataset.fullSrc) {
            mainImg.src = btn.dataset.fullSrc;
            mainImg.srcset = btn.dataset.fullSrcset || '';
          }
          thumbsWrap.querySelectorAll('.floral-product-gallery__thumb').forEach(function (t) {
            t.classList.toggle('is-active', t === btn);
          });
        });
      }

      var holder = panel.querySelector('[data-ffo-qty]');
      var tiles = holder ? Array.prototype.slice.call(holder.querySelectorAll('[data-ffo-tile]')) : [];
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var sellingPlan = form.querySelector('[data-selling-plan-input]');
      if (sellingPlan) { sellingPlan.disabled = true; sellingPlan.value = ''; }
      if (!tiles.length || !idInput) return;
      // Server marks the default_qty tile active; if that variant is not
      // sold right now, fall back to the first tile so the state is visible.
      if (!tiles.some(function (t) { return t.classList.contains('is-active'); })) tiles[0].classList.add('is-active');

      // Quantity tiles go where the theme's tiles lived (above the button).
      var purchase = panel.querySelector('floral-purchase-type') || panel.querySelector('.floral-purchase-type');
      if (purchase && purchase.parentNode) {
        purchase.parentNode.insertBefore(holder, purchase);
        holder.hidden = false;
      }

      // The theme's purchase-type JS rewrites its note line with dynamic
      // Bundle & Save savings ("-$5 at checkout") — on this page that reads
      // as stacking with the 20% offer. This line is the SINGLE OFFER LINE:
      // apply() sets the wanted text per selected tile; the observer holds it.
      var note = panel.querySelector('[data-bs-note]');
      var noteText = panel.dataset.ffoNote || '';
      if (note && noteText) {
        note.textContent = noteText;
        new MutationObserver(function () {
          var want = (panel._ffo && panel._ffo.noteText) || noteText;
          if (note.textContent !== want) note.textContent = want;
        }).observe(note, { childList: true, characterData: true, subtree: true });
      }
      function offerLine(deal) {
        if (!(fsThreshold > 0) || !lineFs || !lineNoFs) return noteText;
        if (deal + 0.005 >= fsThreshold) return lineFs;
        return lineNoFs.replace('[amount]', money(fsThreshold - deal));
      }

      var allowed = tiles.map(function (t) { return String(t.dataset.variantId); });
      panel._ffo = { tiles: tiles, idInput: idInput, qtyInput: qtyInput, allowed: allowed, purchase: purchase, holder: holder, noteText: noteText };

      function activeTile() {
        return tiles.filter(function (t) { return t.classList.contains('is-active'); })[0] || tiles[0];
      }

      function apply() {
        var tile = activeTile();
        idInput.value = tile.dataset.variantId;
        if (qtyInput) qtyInput.value = 1;
        var msrp = parseFloat(tile.dataset.price || '0');
        var deal = Math.round(msrp * (100 - discountPct)) / 100;
        if (note) {
          panel._ffo.noteText = offerLine(deal);
          if (note.textContent !== panel._ffo.noteText) note.textContent = panel._ffo.noteText;
        }
        var atc = panel.querySelector('[data-atc-button]');
        if (atc) {
          atc.type = 'submit';
          var expected = 'Add to Cart <s class="ffo-msrp">' + money(msrp) + '</s> <b class="ffo-deal">' + money(deal) + '</b>';
          // An out-of-stock pack (snippets/floral-oos-notify.liquid) owns this
          // label and enforces "Out of Stock" with its own observer. Writing
          // the price label there makes the two observers rewrite each other
          // forever and freezes the page (2026-10-05, `oos` tag on the default pack).
          if (panel.querySelector('floral-oos-notify')) return;
          if (atc.innerHTML !== expected) atc.innerHTML = expected;
          if (!atc._ffoObserved) {
            atc._ffoObserved = true;
            new MutationObserver(function () {
              var cur = panel.querySelector('[data-atc-button]');
              var want = panel._ffo && panel._ffo.expectedLabel;
              if (cur && want && cur.innerHTML !== want) cur.innerHTML = want;
            }).observe(atc, { childList: true, characterData: true, subtree: true });
          }
          panel._ffo.expectedLabel = expected;
        }
      }
      tiles.forEach(function (t) {
        t.addEventListener('click', function () {
          tiles.forEach(function (x) { x.classList.toggle('is-active', x === t); });
          apply();
        });
      });
      panel._ffo.apply = apply;

      form.addEventListener('submit', function (e) {
        if (allowed.indexOf(String(idInput.value)) === -1) {
          e.preventDefault();
          e.stopImmediatePropagation();
          apply();
          var msg = panel.querySelector('[data-ffo-error]');
          if (msg) { msg.hidden = false; setTimeout(function () { msg.hidden = true; }, 4000); }
          return;
        }
        if (qtyInput) qtyInput.value = 1;
        if (sellingPlan) { sellingPlan.disabled = true; sellingPlan.value = ''; }
      }, true);

      apply();
    }
    Object.keys(panels).forEach(function (k) {
      try { initPanel(panels[k]); }
      catch (err) { console.error('FFO initPanel failed for', k, err); }
    });

    /* ---------- pill helpers ---------- */
    function setActive(btn, on) { btn.classList.toggle('strength-pills__pill--active', !!on); }

    function paintPills() {
      selectors.querySelectorAll('[data-ffo-type]').forEach(function (b) {
        setActive(b, b.dataset.ffoType === state.type);
      });
      selectors.querySelectorAll('[data-ffo-strength]').forEach(function (b) {
        var s = b.dataset.ffoStrength;
        var unavailable = (state.type === 'seltzer' && s !== '2.5') ||
          (state.type && missing[state.type + '-' + s]);
        setActive(b, s === state.strength);
        b.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
        b.tabIndex = unavailable ? -1 : 0;
      });
    }

    /* ---------- state machine ---------- */
    function keyFor() { return state.type + '-' + state.strength; }

    function render(scroll) {
      paintPills();
      var key = keyFor();
      if (!panels[key]) return; // unavailable combo — pills already disabled
      Object.keys(panels).forEach(function (k) { panels[k].hidden = (k !== key); });
      var panel = panels[key];
      var f = panel._ffo || {};
      if (f.holder && f.holder.parentNode) {
        f.holder.parentNode.insertBefore(selectors, f.holder);
      }
      if (offerBlock && f.purchase && f.purchase.parentNode) {
        if (f.purchase.nextSibling) f.purchase.parentNode.insertBefore(offerBlock, f.purchase.nextSibling);
        else f.purchase.parentNode.appendChild(offerBlock);
      }
      if (f.apply) f.apply();
      if (scroll) window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    selectors.querySelectorAll('[data-ffo-type]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.type = b.dataset.ffoType;
        if (state.type === 'seltzer') state.strength = '2.5'; // only option — visible reset
        render(true);
      });
    });
    selectors.querySelectorAll('[data-ffo-strength]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        state.strength = b.dataset.ffoStrength;
        render(true);
      });
    });

    try { render(false); }
    catch (err) { console.error('FFO render failed', err); }
  });
})();
